export default "__VITE_ASSET__WEgCH1kn__"